import { useState } from 'react';

import { useIntl } from 'react-intl';
import { Button, Modal, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';

import { WarningIcon } from 'assets/icons';
import { useAxios } from 'configs/requests';
import { Loading } from 'components/Fetch';
import { CheckIcon } from 'assets/icons';
import { ToastNotificationContent } from 'components/UI';

interface IReplaceImeiModalProps {
  device: IDeviceListItem;
  onClose: () => void;
  onSuccess: () => void;
}

const ReplaceImeiModal = ({ device, onClose, onSuccess }: IReplaceImeiModalProps) => {
  const { formatMessage } = useIntl();
  const [newImei, setNewImei] = useState('');

  const [{ loading }, patchDevice] = useAxios(
    {
      url: `/clinician-gateway/device/${device.deviceId}`,
      method: 'PATCH'
    },
    { manual: true }
  );

  const handleSubmit = () => {
    if (!newImei.trim()) return;
    patchDevice({ data: { imei: newImei.trim() } })
      .then(() => {
        toast(
          <ToastNotificationContent
            icon={<CheckIcon className="icon" />}
            text="replaceImeiSuccessKey"
          />
        );
        onSuccess();
        onClose();
      })
      .catch(() => {
        toast.error(
          <ToastNotificationContent
            icon={<WarningIcon className="icon" />}
            text="replaceImeiErrorKey"
          />
        );
      });
  };

  return (
    <Modal show onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{formatMessage({ id: 'replaceImeiKey' })}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading && <Loading />}
        <Form.Group>
          <Form.Label>{formatMessage({ id: 'newImeiKey' })}</Form.Label>
          <Form.Control
            type="text"
            value={newImei}
            onChange={(e) => setNewImei(e.target.value)}
            placeholder={device.imei || ''}
            autoFocus
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="link" onClick={onClose}>
          {formatMessage({ id: 'Cancel' })}
        </Button>
        <Button variant="primary" onClick={handleSubmit} disabled={!newImei.trim() || loading}>
          {formatMessage({ id: 'save' })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ReplaceImeiModal;
